export default "__VITE_ASSET__CEmKRpB4__"